import React, { useState, useMemo, ChangeEvent } from 'react'
import debounce from 'debounce'
import { FormControl, MenuItem, Chip } from '@material-ui/core'
import { FieldNames, ISelectOption, WeekdayTypes } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { dropdownOptions } from '../../../services/publishSchedule'
import { usePublishSchedule } from '../hooks'
import { StyledMultiselect } from '../styled'

export const RecurrenceWeekdays = () => {
  const [{ fieldValues }, dispatch] = usePublishSchedule()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const fieldValue = fieldValues[FieldNames.recurrenceWeekdays]

  const debouncedDropdownClose = useMemo(
    () => debounce(() => { setDropdownOpen(false) }, 1500),
    []
  )

  const handleChange = ({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
    const weekdays = value as any as number[]
    debouncedDropdownClose()
    dispatch(setFieldValue(FieldNames.recurrenceWeekdays, weekdays.sort((a: number, b: number) => a - b)))
  }

  const handleDelete = (value: WeekdayTypes) => dispatch(setFieldValue(
    FieldNames.recurrenceWeekdays,
    fieldValue.filter((day: WeekdayTypes) => day !== value)
  ))

  const selectRender = (selected: any) => {
    const selectedOptions = dropdownOptions[FieldNames.recurrenceWeekdays].filter((
      option: ISelectOption<WeekdayTypes>
    ) => fieldValue.includes(option.value))
    if (selected && selected.length === 0) {
      return 'Select weekdays'
    }
    return selectedOptions && (selectedOptions).map(({ value, label }: ISelectOption<WeekdayTypes>) => {
      return (
        <Chip
          key={value}
          label={label}
          onDelete={() => handleDelete(value)}
        />
      )
    })
  }

  return (
    <FormControl margin="dense">
      <StyledMultiselect
        id="auto-weekday-dropdown-select"
        classes={{
          select: 'weekday-select',
        }}
        multiple
        displayEmpty
        open={dropdownOpen}
        value={fieldValue}
        renderValue={selectRender}
        onChange={handleChange}
        onOpen={() => { setDropdownOpen(true) }}
        onClose={() => { setDropdownOpen(false) }}
      >
        {dropdownOptions[FieldNames.recurrenceWeekdays].map(({ value, label }: ISelectOption<WeekdayTypes>) => (
          <MenuItem key={value} value={value}>{label}</MenuItem>
        ))}
      </StyledMultiselect>
    </FormControl>
  )
}
